<template>
  <div class="gc-grid-footer-css-v2">
    <div class="gc-grid-footer" id="grid-footer">
      <div class="gc-grid-footer-left" v-if="showLeftContainer">
        <slot name="leftContent"> </slot>
      </div>
      <div class="gc-grid-footer-right" v-if="showRightContainer">
        <slot name="rightContent"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showLeftContainer: {
      type: Boolean,
      default: true,
    },
    showRightContainer: {
      type: Boolean,
      default: true,
    },
    refreshKey: {
      type: Number,
      default: 0,
    },
  },
  mixins: [],
  created() {
    // window.addEventListener("resize", this.handleResizeFooter);
  },
  destroyed() {
    this.$store.dispatch("ui/setGridFooterHeight", 0);
  },
  mounted() {
    this.handleResizeFooter(null);
  },
  methods: {
    handleResizeFooter() {
      let clientHeight = 0;
      if (document.getElementById("grid-footer")) {
        clientHeight = document.getElementById("grid-footer").clientHeight;
      }
      this.$store.dispatch("ui/setGridFooterHeight", clientHeight);
    },
  },
};
</script>

<style lang="scss">
.gc-grid-footer {
  display: flex;
  background: #525464;
  color: white;
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;

  .gc-grid-footer-left {
    display: flex;
    flex-grow: 1;
  }

  .gc-grid-footer-right {
    display: flex;
  }

  .gc-grid-footer-item {
    align-items: baseline !important;
    padding-left: 10px;
    padding-right: 5px;
  }
  .gc-grid-footer-item {
    align-items: baseline !important;
    padding-left: 10px;
    padding-right: 5px;
    display: inline-flex;
  }

  .gc-grid-footer-item input {
    color: white;
  }

  .gc-grid-footer-item .dx-numberbox::after {
    border-bottom: unset !important;
  }

  .gc-grid-footer-item .dx-numberbox::before {
    border-bottom: unset !important;
  }

  .gc-grid-footer-item .dx-state-disabled {
    opacity: 1;
  }
}
</style>
